// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2u9wg","title":"ClientReferral_title__2hQAa","itemText":"ClientReferral_itemText__1M2GI"};